// extracted by mini-css-extract-plugin
export default {"container":"styles_container__awfC1","image":"styles_image__qSiBZ","cards":"styles_cards__fr-f8","card":"styles_card__O9Api"};